import { useEffect, useState } from "react";
import ReportTabHeader from "./ReportTabHeader";
import AquaReportTable from "./AquaReportTable";
import { downloadReport, getAgentList, getReport } from "../../services/aquaServices";
import { getFomattedOutletData } from "../../helper";
import {
  getFormattedAgentList,
  getFormattedReportData,
} from "../../pages/AquaZone/aquahelper";
import { getFormattedDate } from "../getFormattedDate";
import { toast } from "react-toastify";
import { ToastMessage } from "../ToastMessage";

const REPORT_FILTER = [
  { label: "All", value: "all" },
  { label: "Customer", value: "customer" },
  { label: "Agent", value: "source" },
];

const AquaZoneSlotTabContent = () => {
  const [reportDate, setReportDate] = useState<Date | null | any>(new Date());
  // const [toDate, setToDate] = useState(new Date());
  const [selectedFilter, setFilter] = useState(0);
  const [agentList, setAgentList] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [agent, setAgent] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  let today = new Date();

  useEffect(() => {
    fetchReportData("", reportDate, "all", "", 1);
  }, []);

  const fetchReportData = async (
    agentId: string,
    reportDate: string,
    filter: any,
    searchText: string,
    page: number
  ) => {
    let date = getFormattedDate(reportDate, "YYYY-MM-DD");
    let filterType = REPORT_FILTER[filter].value;
    if (REPORT_FILTER[filter].value === "source" && !agent) {
      toast.warn("Please select agent");
    } else {
      let res = await getReport(agentId, date, filterType, searchText, page);
      setReportData(getFormattedReportData(res?.data?.data));
    }
  };

  const handleFilter = (index: any) => {
    if (index !== 2) {
      setAgent("");
    }
    setFilter(index);
  };

  const handleClearFilter = () => {
    setFilter(0);
  };

  useEffect(() => {
    fetchAgentList();
  }, []);

  const fetchAgentList = async () => {
    let res = await getAgentList();
    setAgentList(getFormattedAgentList(res?.data?.data, "Select Agent"));
  };

  const handleAgentSelect = (e: any) => {
    setAgent(e?.target.value);
  };

  const handleSetReportDate = (e: any) => {
    setReportDate(e);
    fetchReportData(agent, e, selectedFilter, searchQuery, 1); // NEED TO REVISIT
  };

  const handleSearch = (value: any) => {
    setSearchQuery(value);
    fetchReportData(agent, reportDate, selectedFilter, value, 1); // NEED TO REVISIT
  };

  const handleSaveFilter = () => {
    fetchReportData(agent, reportDate, selectedFilter, searchQuery, 1); // NEED TO REVISIT
  };

  const handleDownload = async () => {
    let date = getFormattedDate(reportDate, "YYYY-MM-DD");
    let filterType = REPORT_FILTER[selectedFilter].value;
    if (REPORT_FILTER[selectedFilter].value === "source" && !agent) {
      toast.warn("Please select agent");
    } else {
      try {
        const response = await downloadReport(agent, date, filterType, searchQuery);
        const outputFilename = `transactions.xlsx`;
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        console.log(url);        
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", outputFilename);
        document.body.appendChild(link);
        link.click();
      } catch (error: any) {
        if (navigator.onLine) {
          toast.error(error.message, { hideProgressBar: true });
        } else {
          toast.error(
            <ToastMessage
              message="You're offline now"
              subMessage="Oops! Internet is disconnected."
            />,
            {
              hideProgressBar: true,
            }
          );
        }
      }
    }
  };

  return (
    <>
      <ReportTabHeader
        today={today}
        reportDate={reportDate}
        onSetReportDate={handleSetReportDate}
        onFilterSelect={handleFilter}
        selectedFilter={selectedFilter}
        filterEntities={REPORT_FILTER}
        onClearFilter={handleClearFilter}
        agentList={agentList}
        onAgentSelect={handleAgentSelect}
        searchQuery={searchQuery}
        onSearch={handleSearch}
        onSaveFilter={handleSaveFilter}
        onDownload={handleDownload}
        agent={agent}
      />
      <AquaReportTable data={reportData} isTableDataLoading={false} />
    </>
  );
};

export default AquaZoneSlotTabContent;
